import axios from "axios";
import { environment } from "../environment";

// Clear all auth state and hard-redirect to the login page.
// Exported so non-axios callers (e.g. fetch-based uploads) can trigger the same logout.
export const forceLogout = () => {
  sessionStorage.removeItem("token");
  sessionStorage.removeItem("authUser");
  if (window.location.pathname !== "/login") {
    window.location.href = "/login";
  }
};

// Create an Axios instance.
// Dev: fixed localhost value (the CRA dev server has no API). Production build:
// same origin that serves the app (see src/environment.js).
const api = axios.create({
  baseURL: environment.API_PATH,
});

// Add a response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.code === "ERR_NETWORK") {
      console.error("Network error occurred");
    }

    const status = error.response?.status;
    // 401 = session invalid/expired, 498 = invalid token. Force an immediate logout.
    if (status === 401 || status === 498) {
      forceLogout();
    }
    return Promise.reject(error);
  }
);

// Add a request interceptor
api.interceptors.request.use(
  (config) => {
    const authToken = sessionStorage.getItem("token");
    config.headers = {
      ...config.headers,
      "Content-Type": "application/json",
      Authorization: authToken ? `Bearer ${authToken}` : "",
    };

    return config;
  },
  (error) => Promise.reject(error)
);

export default api;
